import React, { useMemo, useRef, useState, useEffect,useCallback} from "react";
import PerfectScrollbar from "perfect-scrollbar";
import {Route, Switch, useLocation} from "react-router-dom";
import {
	 Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
	Button,
} from "reactstrap";
import {AnimatePresence} from "framer-motion";
import Navbar from "components/Navbars/Navbar.js";
import Footer from "components/Footers/Footer.js";
import Sidebar from "components/Sidebars/Sidebar.js";
import Loader from "components/Core/Loader";
import routes from "routes.js";
import NotificationAlert from "react-notification-alert";
import Notify from "../lib/Utils/Alert";
import AuthData from "../lib/Core/AuthData";
import BrandsContext from "contexts/brandsContext";
import Brand from "lib/Core/Backend/Controllers/Brand";
import CatalogsContext from "contexts/catalogsContext";
import Catalogs from "lib/Core/Backend/Controllers/Catalogs";
import Category from "lib/Core/Backend/Controllers/Category";
import ErrorModal from "components/Core/ErrorModal";
import CardType from "lib/Core/Backend/Controllers/CardType";
let ps;
const securityGroups = [
	"SYSTEM_MANAGER",
	"INTERNAL_MANAGER",
	"INTERNAL",
	"PRODUCT_MANAGER",
	"SUPPLIER_MANAGER",
	"COMMERCIAL_MANAGER",
	"ACCOUNTANT_MANAGER",
	"CUSTOMER_SERVICE"
]
const authData = new AuthData(securityGroups);
const token = authData.token;
const brandsCtl = new Brand(token)
const catalogsCtl = new Catalogs(token)
const categoriesCtl = new Category(token)
function AdminLayout(props)
{
	const mainPanel = React.useRef();
	const location = useLocation();
	const notifRef = useRef();
	const [startLoaderFrom, setStartLoaderFrom] = useState("");
	const [title,setTitle] = useState();
	const [accessRoles, setAccessRoles] = useState([]);
	const cardTypeCtl = useMemo(() => new CardType(token),[token]);
	React.useEffect(() =>
	{
		if (navigator.platform.indexOf("Win") > -1)
		{
			ps = new PerfectScrollbar(mainPanel.current);
			document.body.classList.toggle("perfect-scrollbar-on");
		}
		return function cleanup()
		{
			if (navigator.platform.indexOf("Win") > -1)
			{
				ps.destroy();
				document.body.classList.toggle("perfect-scrollbar-on");
			}
		};
	});
	React.useEffect(() =>
	{
		mainPanel.current.scrollTop = 0;
		document.scrollingElement.scrollTop = 0;
	}, [location]);
	const [brands, setBrands] = useState([]);
	const [countries, setCountries] = useState([]);
	const [currencies, setCurrencies] = useState([]);
	const [region,setRegion] = useState([]);
	const [paymentOptions, setPaymentOptions] = useState([]);
	const [contactTypes, setcontactTypes] = useState([]);
	const [categories, setCategories] = useState([]);
	const [allowedRoutes, setAllowedRoutes] = useState([]);
	const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');
	const [maintainModal,setMainTainModal] = React.useState(false);
	const toggleConfirm = () => setMainTainModal(!maintainModal);
	const handleMaintainModalOff = () =>{
		setMainTainModal(false);
	}

	React.useEffect(() => {
    let accessToken = JSON.parse(sessionStorage.getItem('accessToken'))
    if (accessToken && accessToken.decodedToken && accessToken.decodedToken["cognito:groups"]) {
      let cognitoGroups = accessToken.decodedToken['cognito:groups']
      setAccessRoles(cognitoGroups);
      let filteredRoutes = routes.filter(route => route.layout === '/admin')
      filteredRoutes = filteredRoutes.filter(
        (route) => route.allowedRoles?.length === 0 || route.allowedRoles.some((role) => cognitoGroups.includes(role))
      );
      setAllowedRoutes(filteredRoutes);
    } 
	
	
	// else {
	// 	document.location.href = "/auth/login";
	//   }
  }, []);


const [inactive, setInactive] = useState(false);
const inactivityTime = 10 * 60 * 1000; 

const handleLogout = useCallback(() => {
	document.location.href = "/auth/login";
	sessionStorage.removeItem('accessToken')
}, []);

const resetTimer = useCallback(() => {
	setInactive(false);
	clearTimeout(window.inactivityTimeout);
	window.inactivityTimeout = setTimeout(() => {
		setInactive(true);
	}, inactivityTime);
}, [inactivityTime]);

useEffect(() => {
	const events = ["mousemove", "keydown", "click"];
	const eventHandler = () => resetTimer();
	
	events.forEach(event => window.addEventListener(event, eventHandler));
	resetTimer();

	return () => {
		events.forEach(event => window.removeEventListener(event, eventHandler));
		clearTimeout(window.inactivityTimeout);
	};
}, [resetTimer]);

useEffect(() => {
	if (inactive) {
		handleLogout();
	}
}, [inactive, handleLogout]);

  const hideErrorModal = () => {
	setIsErrorModalOpen(false);
	setErrorMessage('');
  };
const mainatainBackend = () => {
	fetch(`${process.env.REACT_APP_BACKEND_URL}private/auth/maintenance-mode/${true}`)
	
	.then((response) => {
	  
	  toggleConfirm();
	})
	.catch((error) => {
		console.error(`Error: ${error}`);
})
}
let url;
let maintainCalled = false;
const fetchData = () => {
 url = process.env.REACT_APP_MAINTAIN_URL
    fetch(url)
        .then((response) => {
            if (!response.ok) {
			 if (response.status === 502 || response.status === 503 || response.status === 504) {
						if(!maintainCalled){
						maintainCalled = true;
						mainatainBackend();
						}
					}			
			throw new Error(`HTTP error! Status: ${response.status}`);
				
            }
            return response.json();
        })
        .then((data) => {
			if(data.Status === "OK"){
				
			}else{
				if (!maintainCalled) { 
					maintainCalled = true;
					mainatainBackend();
				}
			}
            
        })
        .catch((error) => {
            console.error(`Error: ${error}`);
        })
       
};
  let pollingInterval;
  useEffect(() => {
	pollingInterval = setInterval(() => {
	  fetchData();
	}, 20000);
  
	return () => {
	  clearInterval(pollingInterval);
	};
  }, []);
	React.useEffect(() => {
		brandsCtl.all(data => {
			if(!(data.error || data.errorMessage)){
				setBrands(data.result)
				
			}
		})
		catalogsCtl.countries(data => {
			if(!(data.error || data.errorMessage)){
				setCountries(data)
			}
		})
		catalogsCtl.paymentOptions(data => {
			if(!(data.error || data.errorMessage)){
				setPaymentOptions(data)
			}
		})
		catalogsCtl.currencies(data => {
			if(!(data.error || data.errorMessage)){
				setCurrencies(data)
			}
		})
		
		catalogsCtl.contactTypes(data => {
			if(!(data.error || data.errorMessage)){
				setcontactTypes(data)
			}
		})
		categoriesCtl.all(data => {
			if(!(data.error || data.errorMessage)){
				setCategories(data.sort((a, b) => a.name.localeCompare(b.name)))
			}
		})
	},[])

	if(!authData.validateSecurityGroups())
	{
		document.location.href = "/auth/login";
		return;
	}
	import("bootstrap/dist/css/bootstrap.css").then(() => import("assets/scss/paper-dashboard.scss?v=1.3.0").then(() => import ("perfect-scrollbar/css/perfect-scrollbar.css")));
	return (
		<>
		<CatalogsContext.Provider 
			value={{
				paymentOptions: paymentOptions,
				countries: countries,
				contactTypes: contactTypes,
				currencies: currencies,
				categories: categories,
			}} 
		>
			<BrandsContext.Provider value={brands}>
				<div className="wrapper">
					<NotificationAlert ref={notifRef}/>
					<Loader startLoadingFrom={startLoaderFrom}/>
					<Sidebar {...props} routes={allowedRoutes} startLoader={from => setStartLoaderFrom(from)}/>
					<div className="main-panel" ref={mainPanel}>
						<Navbar {...props} title={title}/>
						<AnimatePresence initial={true} exitBeforeEnter={true}>
							<Switch>
							{allowedRoutes.map((prop, key) =>
								{
									return (<Route
										path={prop.layout + prop.path}
										component={(newProps) => <prop.component
											{...newProps}
											accessRoles={accessRoles}
											token={token} 
											notify={(type, message) => Notify(notifRef, type, message)}
											setTitle={title => setTitle(title)} 
										/>}
										key={key}
									/>);
								})}

							</Switch>
						</AnimatePresence>
						<Footer fluid/>
					</div>
				</div>
			</BrandsContext.Provider>
		</CatalogsContext.Provider>
		<ErrorModal isOpen={isErrorModalOpen} toggle={hideErrorModal} errorMessage={errorMessage} />
		<Modal isOpen={maintainModal} toggle={toggleConfirm} centered={true} backdrop="static">
                    <ModalHeader className="custom_header_colour align-items-center" toggle={toggleConfirm}>
                        <h3 className='mb-0 ' style={{ fontSize: '20px' }}>Server Alert</h3>
                    </ModalHeader>
                    <ModalBody>
                        <p className="card-just-text"  style ={{fontSize:"20px"}}>
                           The Server is on Maintaince 
                        </p>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={handleMaintainModalOff}>Cancel</Button>   
                    </ModalFooter>
                </Modal>
		</>
	);
}

export default AdminLayout;
